/**
 * Created by Howard on 12/3/2020.
 */

(function($) {
    $('document').ready(function () {
        $('.toggle-box').click(function() {
            $(this).toggleClass('toggled');
        });
    });
})(jQuery);
